import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';
import type { HeatmapWidgetEntity } from '../../heatmap-widget/HeatmapWidget.entity';

import { HeatmapWidgetWrapper } from '../../heatmap-widget/HeatmapWidget';

export function renderHeatmapWidget(widget: HeatmapWidgetEntity, options: TWidgetRendererOptions): TRenderWidget {
  return () => <HeatmapWidgetWrapper entity={widget} options={options} />;
}
